const TermosBusca = ({ acoes }) => {
    const termos = acoes
      ?.filter((a) => a.tipo_acao === "buscar" && a.termo_busca)
      .map((a) => a.termo_busca.trim().toLowerCase());
  
    const contagem = {};
    termos.forEach((termo) => {
      contagem[termo] = (contagem[termo] || 0) + 1;
    });
  
    const termosOrdenados = Object.entries(contagem)
      .map(([termo, total]) => ({ termo, total }))
      .sort((a, b) => b.total - a.total);
  
    const maior = termosOrdenados[0]?.total || 1;
  
    return (
      <div className="bg-white rounded-2xl shadow p-4">
        <h3 className="text-sm font-semibold text-gray-600 mb-3">
          Termos de busca
        </h3>
  
        {termosOrdenados.length > 0 ? (
          <ul className="space-y-2 max-h-[260px] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            {termosOrdenados.map(({ termo, total }) => (
              <li key={termo}>
                <div className="flex justify-between text-sm text-gray-700 mb-1">
                  <span className="capitalize">{termo}</span>
                  <span className="text-xs text-gray-500">{total}</span>
                </div>
                <div className="w-full bg-gray-100 h-2 rounded-full">
                  <div
                    className="h-2 bg-emerald-500 rounded-full"
                    style={{ width: `${(total / maior) * 100}%` }}
                  />
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-400 text-center">
            Nenhuma busca realizada
          </p>
        )}
      </div>
    );
  };
  
  export default TermosBusca;
  